import { feetToMeters } from "@skydio/math";

export const DEFAULT_FLY_TO_POINT_HEIGHT = feetToMeters(200); // 200 ft as defined in SW-66159
export const DEFAULT_FLY_TO_POINT_OFFSET = feetToMeters(0); // Default off with 0m because the slider is the only UI element
